import { DataSourcesQueries } from '@frontend/api-data-sources';

export const useIsIntegratedOffice = () => {
  const { isIntegratedOffice, isLoading } = DataSourcesQueries.useGetAccessibleIntegrations();

  return { isIntegratedOffice, isLoading };
};
